import { render, staticRenderFns } from "./EmailConfirmationPage.vue?vue&type=template&id=2f6bab6d&"
var script = {}
import style0 from "./EmailConfirmationPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports